import React from 'react';
import { Box, Button, TextField, CircularProgress, Link } from '@mui/material';
import type { AuthView } from './types';

interface LoginFormProps {
  email: string;
  setEmail: (v: string) => void;
  password: string;
  setPassword: (v: string) => void;
  loading: boolean;
  handleLoginSubmit: (e: React.SyntheticEvent) => void;
  handleViewChange: (view: AuthView) => void;
}

export const LoginForm: React.FC<LoginFormProps> = ({
  email,
  setEmail,
  password,
  setPassword,
  loading,
  handleLoginSubmit,
  handleViewChange,
}) => (
  <form onSubmit={handleLoginSubmit}>
    <TextField
      fullWidth
      label="Email Address"
      variant="outlined"
      margin="normal"
      value={email}
      onChange={(e) => setEmail(e.target.value)}
      disabled={loading}
      autoComplete="email"
    />
    <TextField
      fullWidth
      label="Password"
      type="password"
      variant="outlined"
      margin="normal"
      value={password}
      onChange={(e) => setPassword(e.target.value)}
      disabled={loading}
      autoComplete="current-password"
    />

    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
      <Link
        component="button"
        type="button"
        variant="body2"
        onClick={() => handleViewChange('forgot')}
        disabled={loading}
        sx={{ color: '#000', fontWeight: 500, textDecoration: 'underline', '&:hover': { color: '#333' } }}
      >
        Forgot Password?
      </Link>
    </Box>

    <Button
      fullWidth
      type="submit"
      variant="contained"
      size="large"
      disabled={loading}
      sx={{ mt: 3, height: 48, backgroundColor: '#FFBC0D', color: '#000', fontWeight: 700, '&:hover': { backgroundColor: '#e5a90c' } }}
    >
      {loading ? <CircularProgress size={24} /> : 'Sign In'}
    </Button>
  </form>
);
